
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { usePollSocialMetrics } from '@/hooks/usePollSocialMetrics';
import LikeButton from '@/components/social/LikeButton';
import ShareButton from '@/components/social/ShareButton';

interface PollDetailsLinkProps {
  url: string;
  pollId: string;
}

const PollDetailsLink: React.FC<PollDetailsLinkProps> = ({ url, pollId }) => {
  const { metrics: socialMetrics } = usePollSocialMetrics(pollId);
  
  return (
    <div className="flex flex-col gap-4 pt-4 border-t border-gray-100 dark:border-gray-800 w-full overflow-hidden">
      {/* Social Actions Row */}
      <div className="flex flex-wrap justify-center sm:justify-start items-center gap-2 overflow-x-auto">
        <LikeButton 
          cardId={pollId}
          initialLikes={socialMetrics?.likesCount || 0}
          showCount={true}
          size="sm"
          contentType="poll"
        />
        
        <Link to={`${url}#comments`}>
          <Button variant="outline" size="sm" className="whitespace-nowrap">
            <MessageSquare className="h-4 w-4 mr-1" />
            {socialMetrics?.commentsCount || 0}
          </Button>
        </Link>
        
        <ShareButton
          contentId={pollId}
          contentType="poll"
          initialShares={socialMetrics?.sharesCount || 0}
          showCount={true}
          size="sm"
          url={`${window.location.origin}${url}`}
          title="Poll"
        />
      </div>
      
      {/* View Details Button - Right aligned on desktop, centered on mobile */}
      <div className="flex justify-center sm:justify-end pt-2">
        <Link to={url}>
          <Button variant="outline" className="px-4 sm:px-6 py-2 whitespace-nowrap">
            View Details <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PollDetailsLink;
